<template>
  <div class="view view-curso">
    <top-bar v-if="isPortalReady" />

    <div class="container">
        <img :src="pagina.foto_principal" >
        <h3 class="curso-clases-title">{{pagina.titulo}}</h3>

        <div v-html="pagina.descripcion">
       {{pagina.descripcion}}
        </div>


        <div>
            <img  v-for="imagen in pagina.paginas_imagenes" :key="imagen.id" style="width:200px" :src="imagen.imagen.replace('http:', 'https:')" class="img-thumbnail img-fluid">
        </div>


    </div>
    <site-footer v-if="isPortalReady" :verFooter="true"/>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { Carousel } from "bootstrap-vue/es/components";
import TopBar from "../components/TopBar";
import CursoList from "../components/CursoList";
import SiteFooter from "../components/SiteFooter";
import ContenidoList from "../components/ContenidoList";
import Spinner from "../components/Spinner";

Vue.use(Carousel);

export default {
	name: "pagina",
	components: {
		TopBar,
		CursoList,
		SiteFooter,
		Spinner,
		ContenidoList
	},
	data() {
		return {
			isLoadingContenido: false,
			pagina: []
		};
	},
    computed: {
		...mapState(["portal", "user", "isPortalReady"])
	},
    methods: {
        cargarPagina() {
            this.$api
            .getPaginaInfo(this.$route.params.guid)
            .then(response => {
                if(typeof response.data.error!=='undefined'){
                     this.$router.push({
                        name: "error404"
                    });
                }
                this.pagina = response.data;
            })
            .catch(error => {
                this.$router.push({
                    name: "error404"
                });
            });
        }
	},
    created(){
       this.cargarPagina()
    }
};
</script>
